import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

import { $Elements, Durations } from '../global/constants';

export let mapInitialized = false;
export let mapMarkers = [];

mapboxgl.accessToken = 'pk.eyJ1IjoiZHVjb3VydDMzNzYwIiwiYSI6ImNtZHNsNGp0MzB1YnUybXM2Zzh3dnh2Y3oifQ.asOWric6445DEQfWcMZqvA';

export const map = (document.getElementById('main-map')) ? new mapboxgl.Map({
	container: 'main-map',
	zoom: 9,
	center: [-0.1732, 44.6991],
	pitch: 0,
	bearing: 0,
	antialias: true,
	interactive: false,
	logoPosition: 'bottom-right',
	attributionControl: true,
	style: 'mapbox://styles/ducourt33760/cmkqq2pn5000001saeqyncfy5',
}) : null;

if(map) {

	map.on('load', () => {

		map.setStyle({ ...map.getStyle(), 'transition': { duration: Durations.animations.ms, delay: 0 } });
		map.addControl(new mapboxgl.ScaleControl(), 'top-right');

		mapInitialized = true;
		$Elements.document.trigger('map.initialized');
	});
}

export function hideParcellaires() {
	map.setPaintProperty('parcellaires', 'fill-opacity', 0);
}

export function showParcellaire(name) {
	map.setPaintProperty('parcellaires', 'fill-opacity', ['match', ['get', 'CHT'], name, 1, 0]);
}

export function getParcellaireFeatures(name) {
	return map.queryRenderedFeatures({ layers: ['parcellaires'], filter: ['==', ['get', 'CHT'], name] });
}

export function easeTo(location) {

	if(typeof location.duration === 'undefined') {
		location.duration = Durations.animations.ms * 2;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.easeTo({ ...location, essential: true });
	});
}

export function flyTo(location) {

	if(typeof location.duration === 'undefined') {
		location.duration = Durations.animations.ms * 2;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.flyTo({ ...location, essential: true });
	});
}

export function fitBounds(bounds, options = {}) {

	if(typeof options.duration === 'undefined') {
		options.duration = Durations.animations.ms * 2;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.fitBounds(bounds, { ...options, essential: true });
	});
}
